"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Number_1 = require("@pups/utility/build/Number");
const Array_1 = require("@pups/utility/build/Array");
const ColorParser_1 = require("./ColorParser");
const ColorConversions_1 = require("./ColorConversions");
/**
 *
 *
 * @class ColorManager
 */
class ColorManager {
    /**
     * Creates an instance of ColorManager.
     *
     * @param {Types.Color.All} color
     * @memberof ColorManager
     */
    constructor(color) {
        const parsed = ColorParser_1.default.parse(color);
        this.rgb = this.getRgbFromMath(parsed);
        this.hsl = ColorConversions_1.default.rgbToHsl(this.rgb);
        this.hsv = ColorConversions_1.default.rgbToHsv(this.rgb);
        this.hex = ColorConversions_1.default.rgbToHex(this.rgb);
        this.cmyk = ColorConversions_1.default.rgbToCmyk(this.rgb);
        this.setAlpha(['rgba', 'hsla', 'hsva'].indexOf(parsed.type) >= 0 ? parsed.value.length >= 3 ? parsed.value[3] : 1 : 1);
    }
    /**
     *
     *
     * @param {number} [alpha]
     * @memberof ColorManager
     */
    setAlpha(alpha) {
        this.alpha = alpha;
        this.alpha = this.alpha > 1 ? this.alpha / 255 : this.alpha;
    }
    /**
     *
     *
     * @returns {number}
     * @memberof ColorManager
     */
    getAlpha() {
        return this.alpha;
    }
    /**
     *
     *
     * @private
     * @param {Types.Color.Parsing.Match} match
     * @returns {Types.Color.RGB}
     * @memberof ColorManager
     */
    getRgbFromMath(match) {
        switch (match.type) {
            case 'rgb':
            case 'rgba':
                const rgb = Array_1.toFloat(match.value);
                return { r: rgb[0], g: rgb[1], b: rgb[2] };
            case 'hsl':
            case 'hsla':
                const hsl = Array_1.toFloat(match.value);
                return ColorConversions_1.default.hslToRgb({ h: hsl[0], s: hsl[1], l: hsl[2] });
            case 'hsv':
            case 'hsva':
                const hsv = Array_1.toFloat(match.value);
                return ColorConversions_1.default.hsvToRgb({ h: hsv[0], s: hsv[1], v: hsv[2] });
            case 'cmyk':
                const cmyk = Array_1.toFloat(match.value);
                return ColorConversions_1.default.cmykToRgb({ c: cmyk[0], m: cmyk[1], y: cmyk[2], k: cmyk[3] });
            case 'hex3':
            case 'hex4':
            case 'hex6':
            case 'hex8':
                return ColorConversions_1.default.hexToRgb(match.value);
        }
    }
    /**
     *
     *
     * @returns {Types.Color.RGB}
     * @memberof ColorManager
     */
    getRgb() {
        return Object.assign({}, this.rgb);
    }
    /**
     *
     *
     * @returns {Types.Color.HSL}
     * @memberof ColorManager
     */
    getHsl() {
        return Object.assign({}, this.hsl);
    }
    /**
     *
     *
     * @returns {Types.Color.HSV}
     * @memberof ColorManager
     */
    getHsv() {
        return Object.assign({}, this.hsv);
    }
    /**
     *
     *
     * @returns {Types.Color.CMYK}
     * @memberof ColorManager
     */
    getCmyk() {
        return Object.assign({}, this.cmyk);
    }
    /**
     *
     *
     * @private
     * @param {Types.Palette.Format} type
     * @param {number} x
     * @param {number} y
     * @param {number} z
     * @param {boolean} [alpha=false]
     * @param {boolean} [isHslOrHsv=false]
     * @returns
     * @memberof ColorManager
     */
    toString(type, x, y, z, alpha = false, isHslOrHsv = false) {
        const p = isHslOrHsv ? '%' : '';
        return `${type + (alpha ? 'a' : '')}(${Math.round(x)}, ${Math.round(y) + p}, ${Math.round(z) + p}${alpha ? ', ' + this.alpha : ''})`;
    }
    /**
     *
     *
     * @param {boolean} [alpha=false]
     * @returns {string}
     * @memberof ColorManager
     */
    toRGB(alpha = false) {
        return this.toString('rgb', this.rgb.r, this.rgb.g, this.rgb.b, alpha, false);
    }
    /**
     *
     *
     * @param {boolean} [alpha=false]
     * @returns {string}
     * @memberof ColorManager
     */
    toHSL(alpha = false) {
        return this.toString.call(this, 'hsl', Number_1.relativeClamp(this.hsl.h, 0, 1, 0, 360), this.hsl.s * 100, this.hsl.l * 100, alpha, true);
    }
    /**
     *
     *
     * @param {boolean} [alpha=false]
     * @returns {string}
     * @memberof ColorManager
     */
    toHSV(alpha = false) {
        return this.toString.call(this, 'hsv', Number_1.relativeClamp(this.hsv.h, 0, 1, 0, 360), this.hsv.s * 100, this.hsv.v * 100, alpha, true);
    }
    /**
     *
     *
     * @returns {string}
     * @memberof ColorManager
     */
    toCMYK() {
        return `cmyk(${Number_1.fix(this.cmyk.c * 100, 2)}%, ${Number_1.fix(this.cmyk.m * 100, 2)}%, ${Number_1.fix(this.cmyk.y * 100, 2)}%, ${Number_1.fix(this.cmyk.k * 100, 2)}%)`;
    }
    /**
     *
     *
     * @returns {string}
     * @memberof ColorManager
     */
    toHEX() {
        return this.hex;
    }
    /**
     *
     *
     * @returns {string}
     * @memberof ColorManager
     */
    toRGBA() {
        return this.toRGB(true);
    }
    /**
     *
     *
     * @returns {string}
     * @memberof ColorManager
     */
    toHSLA() {
        return this.toHSL(true);
    }
    /**
     *
     *
     * @returns {string}
     * @memberof ColorManager
     */
    toHSVA() {
        return this.toHSV(true);
    }
}
exports.default = ColorManager;
//# sourceMappingURL=ColorManager.js.map